import Model from '@/models/Model'

export default class PchPaymentCondition extends Model {
    resource() {
        return 'pch_payment_condition'
    }
}